import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import type { PaperProps } from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import CardToolTip from "./cards/CardToolTip";

type ChartCardProps = {
  title: React.ReactNode[] | React.ReactNode;
  tooltipContent?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  backgroundColor?: string;
};

const ChartCard = ({
  title,
  tooltipContent,
  children,
  actions,
  backgroundColor,
  ...props
}: ChartCardProps & Omit<PaperProps, "title">): JSX.Element => {
  const titleItems = Array.isArray(title) ? title : [title];
  return (
    <Paper
      elevation={0}
      {...props}
      sx={{
        padding: "16px",
        border: (theme) => `1px solid ${theme.palette.grey[300]}`,
        borderRadius: "8px",
        backgroundColor: backgroundColor ?? "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        ...props.sx,
      }}
    >
      <Stack direction="row" alignItems="center" sx={{ margin: "-16px 0 0 0", minHeight: "56px" }}>
        <Box display={"flex"}>
          {titleItems.map((item, i) => {
            if (i == 0) {
              return (
                <Typography key={i} display="inline" fontWeight={700} fontSize={16} color="label.main">
                  {item}
                </Typography>
              );
            } else {
              return (
                <Typography key={i} display="inline" fontSize={16} color="label.main">
                  &nbsp;· {item}
                </Typography>
              );
            }
          })}

          {Boolean(tooltipContent) && (
            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} ml={1}>
              <CardToolTip tooltipContent={tooltipContent} />
            </Box>
          )}
        </Box>
        <Box sx={{ flex: 1 }}></Box>
        {actions || <div />}
      </Stack>
      <Box>
        <Divider sx={{ marginBottom: "16px" }} />
      </Box>
      {/* Scrollable content area */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          position: "relative",
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE 10+
          "&::-webkit-scrollbar": {
            display: "none", // WebKit browsers
          },
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default ChartCard;
